import React from 'react'
import { Wizard } from 'usbc-web-react-library'
import {mainSteps} from './WizardModel/mainSteps'
import {subSteps} from './WizardModel/subSteps'

function LeagueRegistrationWizard(props) {
    const [wizardState, setWizardState] = React.useState({
        ...props?.initialState
    });

    return (
        <Wizard mainSteps={mainSteps}
            subSteps={subSteps}
            wizardState={wizardState}
            updateWizardState={setWizardState}
            intialPosition={props.intialPosition} />
    )
}

export default LeagueRegistrationWizard